module.exports = __webpack_public_path__ + "img/y-4.4c5b164b.jpg";